import * as React from 'react';
var PanelContext = /*#__PURE__*/React.createContext({});
export default PanelContext;